var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c(
        "div",
        [
          _vm.fetchingContributions && _vm.loading
            ? [
                _c(
                  "div",
                  { staticClass: "content-loader" },
                  [
                    _c(
                      "ContentLoader",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          height: 320,
                          width: 1076,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "1060",
                            height: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "120",
                            rx: "0",
                            ry: "0",
                            width: "1060",
                            height: "80"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "220",
                            rx: "0",
                            ry: "0",
                            width: "1060",
                            height: "100"
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]
            : [
                !_vm.contributions.total
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "supporter-contributions card columns is-multiline pt-5 pb-6 mb-3"
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "column is-full" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "w-648 t-black mx-auto text-center mb-2"
                            },
                            [
                              _vm._v(
                                "If you are aware of more technical details\n                    about\n                    " +
                                  _vm._s(_vm.contributionModel.name) +
                                  ", please get involved and contribute to the database, so individuals\n                    worldwide\n                    can\n                    utilise the experience of others to prevent further injury and death. "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column is-2 mx-auto" },
                          [
                            _c("cat-uxo-contribute", {
                              attrs: {
                                "contribution-model": _vm.contributionModel,
                                "contribution-type": _vm.contributionType,
                                user: _vm.user,
                                button: "Contribute"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "supporter-contributions card p-2 p-sm-4 mb-10"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column flex-md-row justify-content-between align-items-center mb-5"
                          },
                          [
                            _c("h2", { staticClass: "t-orange mb-3 mb-md-0" }, [
                              _vm._v("Member Contributions")
                            ]),
                            _vm._v(" "),
                            _c("cat-uxo-contribute", {
                              attrs: {
                                "contribution-type": _vm.contributionType,
                                "contribution-model": _vm.contributionModel,
                                user: _vm.user,
                                button: "Contribute"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.contributions.data, function(contribution) {
                          return _c("div", { staticClass: "d-flex mb-4" }, [
                            _c("div", { staticClass: "avatar mr-2" }, [
                              _c("span", { staticClass: "avatar__initials" }, [
                                _vm._v(_vm._s(contribution.initials))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "contribution" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "contribution__meta fs-12 font-weight-light t-navy lh-sm mb-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(contribution.name) +
                                        " added a contribution on " +
                                        _vm._s(
                                          _vm.formattedDate(
                                            contribution.created_at
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "contribution__content font-weight-light lh-lg mb-2"
                                  },
                                  [
                                    _c("p", { staticClass: "paragraph" }, [
                                      _vm._v(
                                        _vm._s(contribution.contribution_text)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.getLinks(contribution.contribution_text)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "social-card-wrapper"
                                          },
                                          _vm._l(
                                            _vm.getLinks(
                                              contribution.contribution_text
                                            ),
                                            function(link, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "social-card-container"
                                                },
                                                [
                                                  _c("link-prevue", {
                                                    attrs: {
                                                      apiUrl:
                                                        _vm.$root
                                                          .linkPrevueApiUrl,
                                                      url: link.href
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(props) {
                                                            return [
                                                              props.img ||
                                                              props.title ||
                                                              props.description
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        target:
                                                                          "_blank",
                                                                        href:
                                                                          props.url
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "social-card"
                                                                        },
                                                                        [
                                                                          props.img
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "social-card__image",
                                                                                  style:
                                                                                    "background-image: url('" +
                                                                                    props.img +
                                                                                    "')"
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "social-card__content"
                                                                            },
                                                                            [
                                                                              props.title
                                                                                ? _c(
                                                                                    "h4",
                                                                                    {
                                                                                      staticClass:
                                                                                        "social-card__content-title"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                                        " +
                                                                                          _vm._s(
                                                                                            props.title
                                                                                          )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              props.description
                                                                                ? _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "social-card__content-body"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                                        " +
                                                                                          _vm._s(
                                                                                            props.description
                                                                                          )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c("div")
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                contribution.files.length
                                  ? _c("cat-uxo-thumbnail-gallery", {
                                      attrs: { files: contribution.files }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                contribution.files.length
                                  ? _c("cat-uxo-file-list", {
                                      staticClass:
                                        "d-flex flex-column flex-md-row mt-1",
                                      attrs: {
                                        files: contribution.files,
                                        listStyle: "pill"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        })
                      ],
                      2
                    )
              ],
          _vm._v(" "),
          _vm.contributions.last_page > 1
            ? [
                _c("paginate", {
                  staticClass: "mt-3",
                  attrs: {
                    "page-count": _vm.contributions.last_page,
                    "prev-text": "&nbsp;",
                    "next-text": "&nbsp;",
                    "prev-link-class": "pagination-previous",
                    "next-link-class": "pagination-next",
                    "container-class": "pagination-list",
                    "page-class": "pagination-item",
                    "page-link-class": "pagination-link",
                    "click-handler": _vm.paginate
                  }
                })
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-1 mx-auto text-center mb-1" }, [
      _c("img", {
        staticClass: "icon__email-sent",
        attrs: { src: "/img/icons/contribute.svg", alt: "Email icon" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-full mb-1" }, [
      _c("h1", { staticClass: "w-872 mx-auto text-center" }, [
        _vm._v("Member Contributions")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f9817b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f9817b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SupporterContributions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1f9817b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SupporterContributions.vue
// module chunks = 0 1